import { Options } from '../types';

import Geolocator from './Geolocator';

export default function initGeolocatorService(options: Options) {
  return Geolocator.getInstance(options);
}

export type GeolocatorServices = ReturnType<typeof initGeolocatorService>;
